import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import firebase from 'firebase/app'
import 'firebase/messaging'
import { notifyEnv } from './config'

const firebaseConfig = {
  apiKey: 'AIzaSyDHc89hy8sVBXJrbBnkZ3d9JQK9W5wr9-c',
  authDomain: 'my-e-office.firebaseapp.com',
  databaseURL: 'https://my-e-office.firebaseio.com',
  projectId: 'my-e-office',
  storageBucket: 'my-e-office.appspot.com',
  messagingSenderId: '624879123062',
  appId: '1:624879123062:web:2d810a7f61e5bc0607fd57',
}

const firebaseConfigStg = {
  apiKey: "AIzaSyCNn2YJmzD_9TVxj6PDs-RbYDxeELu_hq4",
  authDomain: "fafu-migrate-noti.firebaseapp.com",
  databaseURL: "https://fafu-migrate-not.firebaseio.com",
  projectId: "fafu-migrate-noti",
  storageBucket: "fafu-migrate-noti.appspot.com",
  messagingSenderId: "24840495043",
  appId: "1:24840495043:web:859518b1aec55980a02776"
};

const finalFireBaseConfig = notifyEnv === 'prod' ? firebaseConfig : firebaseConfigStg

firebase.initializeApp(finalFireBaseConfig)

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
